/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_1_DescInputs */

const en_mk_how_1_desc = /** @type {(inputs: Mk_How_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a workspace and fill in a short company profile — name, field, products, tone of voice.`)
};

const id_mk_how_1_desc = /** @type {(inputs: Mk_How_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat workspace, isi profil singkat perusahaanmu — nama, bidang, produk, tone bicara.`)
};

/**
* | output |
* | --- |
* | "Create a workspace and fill in a short company profile — name, field, products, tone of voice." |
*
* @param {Mk_How_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_1_desc = /** @type {((inputs?: Mk_How_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_1_desc(inputs)
	return en_mk_how_1_desc(inputs)
});